import { Typography } from "@mui/material";
import './purpleairWebpage.css';

const PageAfterHours = () => {
    return (
        <div className='pageContainer' >
            <div className='pageInnerContainer'>

                <Typography variant="h5" gutterBottom>After-hour Activity Videos</Typography>
                <p> Vehicular activity at U.S. Recycling is occurring beyond the permitted operating hours of:<br />
                    <span style={{ marginLeft: 10, lineHeight: '170%' }}><i>Monday - Friday:</i> prior to 7:00 am or later than 7:00 pm<br /></span>
                    <span style={{ marginLeft: 10, lineHeight: '170%' }}><i>Saturday - Sunday:</i> prior to 10:00 am or later than 7:00 pm<br /></span>
                </p>
                - <a href='https://www.youtube.com/playlist?list=PLMX5yJo0lp3pPotfdB-Ts-O0EU7fN3_rC' target='_blank' rel="noreferrer">Video playlist of numerous violations by US Recycling</a>
                <hr />
                <p>
                    <span style={{ fontWeight: 'bold', lineHeight: '2.0em' }}>per City of Sarasota Zoning Sec. 20-4 : Unreasonable sound prohibited<br /></span>
                    c. Loading and unloading. Loading and unloading, opening, closing or other handling of boxes, crates, containers, equipment, building materials, garbage cans or similar objects in such a manner as to annoy, disturb, injure or endanger the comfort, repose, health, peace, or safety of a reasonable person of normal sensibilities between the hours of 7:00 p.m. and 7:00 a.m. on weekdays and 7:00 p.m. and 10:00 a.m. on weekends and holidays in or within fifty (50) yards of any residential real property line or noise-sensitive area. This section shall not apply to solid waste collection activities of a governmental agency or governmental agency contractor.
                </p>
            </div>


        </div>


    );
}

export default PageAfterHours;